import PropTypes from 'prop-types';
import SegmentBasedInplayScoreboardImpl from './segment-based-inplay-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A view to display a segment-based in-play scoreboard.
 *
 * @class SegmentBasedInplayScoreboard
 * @private
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `SegmentBasedInplayScoreboard` component properties.
 *
 * @property {boolean} [showTotalScore = true] - Show total score's column.
 * @property {Array} detailedParticipantsData - A mapped array containing participants, their scores, and servers.
 * @property {boolean} hasServer - Indicates whether the event supports server indication.
 * @property {Array} detailedSegments - A mapped array containing information about sets or periods.
 * @property {object} [displayStrings = {}] - An object containing string translations.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.SegmentBasedInplayScoreboard
 */
const propTypes = {
    ...getPropTypes(),
    showTotalScore: PropTypes.bool,
    detailedParticipantsData: PropTypes.array.isRequired,
    hasServer: PropTypes.bool.isRequired,
    detailedSegments: PropTypes.array.isRequired,
    displayStrings: PropTypes.object,
};

const defaultProps = {
    showTotalScore: true,
    displayStrings: {},
};

export default UIView(
    'SegmentBasedInplayScoreboard',
    SegmentBasedInplayScoreboardImpl,
    propTypes,
    defaultProps
);
